import vv_utils from './vv_utils';
import { fullLoadingInvokeMachine } from "./vv_api";
import setupMfaEmail from './vv_mfa_email';

const mfaEnrollInit_onStart = (el) => {

  const totpConfig = {
    pageAlertbox: document.getElementById("add-totp-alert"),
    formAlertbox: document.getElementById("add-totp-alert"),
    totpImg: document.getElementById('vv-modal-add-totp-img'),
    cancelBtn: null,
    verifyBtn: document.getElementById('vv-modal-add-totp-verify'),
    codeInput: document.getElementById('vv-modal-add-totp-code'),
    rememberChk: document.getElementById('totp_remember_app'),
    form: document.getElementById('vv-modal-add-totp-form'),
    appService: {}
  }
  
  const emailConfig = {
    pageAlertbox: document.getElementById("add-totp-email-alert"),
    formAlertbox: document.getElementById("add-totp-email-alert"),
    verifyTitle: document.getElementById('verifyTitle'),
    cancelBtn: null,
    verifyBtn: document.getElementById('vvModalVerifyCodeUpdateSaveBtn'),
    resendBtn: document.getElementById('vvModalVerifyCodeResendBtn'),
    codeInput: document.getElementById('verificationcode'),
    codeInputFeedback: document.getElementById('vvModalVerifyCodeFeedback'),
    responseToken: "",
    rememberChk: document.getElementById('totp_remember_email'),
    form: document.getElementById('vvModalVerifyCodeForm'),
    emailService: {},
    verifyCodeService: {}
  }

  const fieldFormMap = {
    'code': '#vv-modal-add-totp-code',
  }
  
  function checkValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;
      
      totpConfig.codeInput.value = totpConfig.codeInput.value.replace(/[^\d]+/g, '');

      if (totpConfig.codeInput.value.length === 6 && /^\d+$/.test(totpConfig.codeInput.value)) {
        //
      } else {
        vv_utils.makeInvalid(totpConfig.codeInput);
        valid = false;
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function hide(selector) {
    let hideList = document.querySelectorAll(selector);
    for (let i = 0; i < hideList.length; i=i+1) {
      hideList[i].classList.add("d-none");
    }  
  }

  function unhide(selector) {
    let unhideList = document.querySelectorAll(selector);
    for (let i = 0; i < unhideList.length; i=i+1) {
      unhideList[i].classList.remove("d-none");
    }    
  }

  function initEnroll() {
    let allow_totp_app = false;
    let allow_totp_email = false;

    let unhideList = {};
    let hideList = {};

    if (window.vv_tenant_data.allow_totp_app) {
      allow_totp_app=true;
    } else {
      allow_totp_app=false;
    }

    if (window.vv_tenant_data.allow_totp_email) {
      allow_totp_email=true;
    } else {
      allow_totp_email=false;
    }

    if (allow_totp_email && allow_totp_app) {
      unhide('.show-on-both');
      
      const appVerify = document.getElementById('app-verify');
      const emailVerify = document.getElementById('email-verify');

      appVerify.addEventListener('click', (event) => {
        totpConfig.appService.send("INIT_COMPLETE");
        hide('.show-on-both, .show-on-email');
        unhide('.show-on-app');
      })
      emailVerify.addEventListener('click', (event) => {
        setupMfaEmail(emailConfig);
        emailConfig.emailService.send("INIT_COMPLETE");
        hide('.show-on-both, .show-on-app');
        unhide('.show-on-email');
      })

    } else if (allow_totp_email && !allow_totp_app) {
      setupMfaEmail(emailConfig);
      emailConfig.emailService.send("INIT_COMPLETE");
      unhide('.show-on-email');
    } else if (!allow_totp_email && allow_totp_app) {
      totpConfig.appService.send("INIT_COMPLETE");
      unhide('.show-on-app');
    }

  }

  function load(context, event) {

    

    const enrollReq = {
    }

    //don't make the call if it has already been loaded
    if (!totpConfig.codeInput.getAttribute("data-token")) {
      return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/mfa/totp/app/enroll`, enrollReq);
    }
    return Promise.resolve({});
  }

  function update(context, event) {

    const verifyReq = {
      "token": totpConfig.codeInput.getAttribute("data-token"),
      "remember_device": totpConfig.rememberChk.checked,
      "code": totpConfig.codeInput.value,
    }

    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/mfa/totp/app/verify`, verifyReq);
  }

  const { interpret } = window.XState;
  totpConfig.appService = interpret(
    fullLoadingInvokeMachine.withConfig({
      actions: {
        loaded: (context, event) => {
          
          
          
          vv_utils.clearInputValidation(totpConfig.form);
          vv_utils.clearalert(totpConfig.formAlertbox);
          vv_utils.clearalert(totpConfig.pageAlertbox);
          if (!totpConfig.codeInput.getAttribute("data-token")) {
            let generateRes = context.data;
            const qrcodeBlob = new Blob([generateRes.image], { type: 'image/svg+xml' });
            totpConfig.totpImg.src = URL.createObjectURL(qrcodeBlob);
            
            totpConfig.codeInput.setAttribute("data-token", generateRes.token)
          }
          totpConfig.codeInput.value = "";
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(totpConfig.form);
          vv_utils.clearalert(totpConfig.formAlertbox);
          vv_utils.clearalert(totpConfig.pageAlertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", totpConfig.formAlertbox);
        },
        validationSucceeded: (context, event) => {
          
          
          
          totpConfig.appService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          //TODO make this for cred object not password
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, fieldFormMap);
          }

          if (context.error) {
            if (context.error.code === 'totp_failure') {
              vv_utils.showStateErrors("Incorrect TOTP code", {}, totpConfig.formAlertbox);
            } else {            
              vv_utils.logError(context.error);
              vv_utils.showStateErrors("There was an unexpected error", context.error, totpConfig.formAlertbox);
            }
          }
        },
        actionSucceeded: (context, event) => {
           
          totpConfig.appService.send("RE_INIT");
          totpConfig.appService.send("INIT_COMPLETE");

          if (context.data.redirect) {
            window.location.assign(context.data.redirect);
            return;
          } else {
            vv_utils.showalert("Invalid response from verification.", "danger", totpConfig.formAlertbox);
            return;
          }

        }
      },
      services: {
        loading_service: (context, event) => load(context, event),
        validate_service: (context, event) => checkValidity(context, event),
        action_service: (context, event) => update(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  vv_utils.AttachAndSendFormEventsToMachineService(totpConfig.form, totpConfig.appService, 'input[type="checkbox"]', 'change');
  vv_utils.AttachAndSendFormEventsToMachineService(totpConfig.form, totpConfig.appService, 'input', 'input');
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(totpConfig.form, totpConfig.appService, (e)=>{if (e.preventDefault) e.preventDefault()});

/*  totpConfig.verifyBtn.addEventListener('click', (e) => {
    editModalService.send("SUBMIT");
  });*/

  

////////////////////////////////////////////////////////////////////////////////////  
  initEnroll();

}

